import { useUgla3dModel } from "@ugla-france/ugla-3d-library";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const KitchenSelectionPage = () => {
  const state = useUgla3dModel();
  const navigate = useNavigate();

  const kitchenTypes = (() => {
    const map = new Map<string, string>();
    state.getContent().assets.forEach(asset => {
      const nameTag = asset.tags?.find(tag => tag.key === 'name');
      const name = nameTag?.value;
      if (name && !map.has(name)) {
        map.set(name, asset.url);
      }
    });
    return Array.from(map.entries()).map(([name, url]) => ({ name, url }));
  })();

  const selectKitchen = (kitchenName: string) => {
    navigate(`/configurator/${kitchenName}`);
  };

  return (
    <PageContainer>
      <ContentWrapper>
        <Title>Choisissez votre style de cuisine</Title>
        <Subtitle>Sélectionnez un modèle pour commencer la configuration</Subtitle>
        <KitchenGrid>
          {kitchenTypes.map((kitchen, index) => (
            <KitchenCard key={index} onClick={() => selectKitchen(kitchen?.name || '')}>
              <CardImage src={kitchen?.url} alt={kitchen?.name} />
              <CardOverlay>
                <CardName>{kitchen?.name}</CardName>
              </CardOverlay>
            </KitchenCard>
          ))}
        </KitchenGrid>
      </ContentWrapper>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #4b61a2ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
`;

const Title = styled.h1`
  color: white;
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 3rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const KitchenGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 0 1rem;
`;

const KitchenCard = styled.div`
  position: relative;
  height: 300px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  background: #fff;
  
  &:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
  }
  
  &:hover > div {
    opacity: 1;
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CardOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  padding: 2rem 1.5rem 1.5rem;
  opacity: 0.9;
  transition: opacity 0.3s ease;
`;

const CardName = styled.h2`
  color: white;
  font-weight: bold;
  font-size: 1.8rem;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export default KitchenSelectionPage;
